<div class="content flex-center" *ngIf="data" >
    <div *ngIf="safeUrl" class="video-wrapp flex-center">
        <iframe  #iframe [src]='safeUrl' frameborder="0" allow="autoplay;encrypted-media" [width]="data.width" [height]="data.height" ></iframe>
    </div>
</div>